import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/vi";

import VueBarcodeScanner from 'vue-barcode-scanner';
// Filter
import * as filters from "@/filters";

import translateGo from '@/components/translateGo';

import SocketIO from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

Vue.mixin(translateGo);

// Aixos OK
import "@/api/config.js";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

// element-ui
Vue.use(ElementUI, { locale });

const socketConnection = SocketIO(process.env.VUE_APP_REALTIME_URL, {
  reconnection: process.env.VUE_APP_REALTIME_ACTIVE,
});
Vue.use(new VueSocketIO({
  debug: false,
  connection: socketConnection,
}))

Vue.use(VueBarcodeScanner);
// CSS
import "@/static/css/style.css";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
